module.exports = __webpack_public_path__ + "static/media/our-onions.2be5e6ad.jpg";